import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

/**
 * Animasyonlu açılır/kapanır panel (varsayılan kapalı).
 * Başlık tam genişlikte bir butondur; üzerine gelince zemin renklenir ve sağdaki
 * chevron 180° döner → alanın açılır/kapanır olduğu UI/UX olarak net belli olur.
 * Yükseklik, grid-template-rows 0fr↔1fr tekniğiyle içerik yüksekliğine yumuşak geçer.
 */
function Acilir({ baslik, defaultAcik = false, className = '', children }) {
  const [acik, setAcik] = useState(defaultAcik);
  return (
    <div className={`overflow-hidden rounded-xl border border-slate-200 bg-white ${className}`}>
      <button
        type="button"
        onClick={() => setAcik((a) => !a)}
        aria-expanded={acik}
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-50"
      >
        <span>{baslik}</span>
        <ChevronDownIcon
          className={`h-4 w-4 flex-none text-amber-500 transition-transform duration-300 ${acik ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        className="grid transition-all duration-300 ease-in-out"
        style={{ gridTemplateRows: acik ? '1fr' : '0fr' }}
      >
        <div className="min-h-0 overflow-hidden">{children}</div>
      </div>
    </div>
  );
}

export default Acilir;
